import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
  makeStyles,
  Theme,
} from '@material-ui/core';
import { H4Text } from '../../TextVariants';

import { colors } from '../../../theme';

export type ConfirmationDialogProps = {
  open: boolean;
  title?: React.ReactNode;
  message: React.ReactNode;
  confirmAction?: () => void;
  rejectAction?: () => void;
  id?: string;
  confirmText?: string;
  rejectText?: string;
};

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    borderRadius: theme.spacing(1.25),
  },
  actionButtonContainer: {
    display: 'flex',
    flexFlow: 'flex-end',
  },
  actionButtons: {
    color: colors.bright_turquoise,
  },
  msg: {
    fontWeight: 'normal',
  },
}));

const ConfirmationDialog = ({
  open,
  title,
  confirmAction = null,
  rejectAction = null,
  message = '',
  id,
  confirmText = 'Sí',
  rejectText = 'No',
}: ConfirmationDialogProps): JSX.Element => {
  const classes = useStyles();

  const confirmationId =
    typeof id !== 'undefined' ? `${id}-button-dialogconfirmaction` : '';
  const rejectionId =
    typeof id !== 'undefined' ? `${id}-button-dialogrejectaction` : '';

  const displayedMessage =
    typeof message === 'string' ? (
      <H4Text className={classes.msg} data-testid="dialog-msg">
        {message}
      </H4Text>
    ) : (
      message
    );

  return (
    <Dialog open={open} classes={{ paper: classes.root }}>
      {title && <DialogTitle data-testid="dialog-title">{title}</DialogTitle>}
      <DialogContent>
        <DialogContentText>{displayedMessage}</DialogContentText>
      </DialogContent>
      <DialogActions className={classes.actionButtonContainer}>
        <Button
          data-testid="confirm-action"
          className={classes.actionButtons}
          autoFocus
          onClick={confirmAction}
          id={confirmationId}
        >
          {confirmText}
        </Button>
        <Button
          data-testid="reject-action"
          className={classes.actionButtons}
          autoFocus
          onClick={rejectAction}
          id={rejectionId}
        >
          {rejectText}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmationDialog;
